import { formatToLocalTime } from "../../../helpers/dateConversion"

export default function TypeTime({ value, description }) {
  return (
    <div>
      <label>{description} </label>
      {formatToLocalTime(value)}
    </div>
  )
}
